import type { FC } from "react";
import { useCallback, useState } from "react";

import { Autocomplete, DotsLoader, ListItemWebsite } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import { SelectedDomain } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/SelectedDomain";
import { DomainSelectionWrapper } from "app/pages/segments/redesigned-wizard/segment-wizard/styledComponents";
import type { ISegmentDomainSelection, ISite } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import { DefaultFetchService } from "app/services/fetchService";

export const DomainSelection: FC<ISegmentDomainSelection> = (props) => {
    const { selectedSite, onSelectMainSite, onClearMainSite, isSelectedSiteAllowed } = props;
    const [isWebsiteSuggestionsDataLoading, setIsWebsiteSuggestionsDataLoading] = useState<boolean>(false);

    const getDomainsData = useCallback(
        async (query: string) => {
            query = query.slice(0, 4).toLowerCase() === "www." ? query.slice(4) : query;
            query = query?.trim();
            if (!query) {
                return [];
            }
            const fetchService = DefaultFetchService.getInstance();
            setIsWebsiteSuggestionsDataLoading(true);
            const items = await fetchService.get<ISite[]>(`/autocomplete/websites?size=9&term=${query}`);
            setIsWebsiteSuggestionsDataLoading(false);
            return items.map(({ name, image }) => (
                <ListItemWebsite
                    key={name}
                    img={image}
                    text={name}
                    onClick={() => onSelectMainSite({ name, image })}
                />
            ));
        },
        [onSelectMainSite],
    );

    return (
        <DomainSelectionWrapper>
            <div>
                {selectedSite?.validation ? (
                    <SelectedDomain
                        onClearMainSite={onClearMainSite}
                        selectedSite={selectedSite}
                        isSelectedSiteAllowed={isSelectedSiteAllowed}
                    />
                ) : (
                    <Autocomplete
                        floating={true}
                        debounce={400}
                        isLoading={isWebsiteSuggestionsDataLoading}
                        loadingComponent={<DotsLoader />}
                        placeholder={i18nFilter()("segmentsWizard.addWebsite.placeholder")}
                        getListItems={getDomainsData}
                        autoFocus={!selectedSite}
                    />
                )}
            </div>
        </DomainSelectionWrapper>
    );
};
